import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

class SearchBar {
  _state = {
    show: false,
    scrollTop: 0,
  };

  // static options = {
  //   pace: 350,
  //   offset: 0
  // }

  constructor(element, options) {
    this._element = element;
    this._options = { ...SearchBar.options, ...options };
    this._cacheSelectors();
    this._initialize();
  }

  _cacheSelectors() {
    this._elements = {
      html: document.documentElement,
      body: document.querySelector('body'),
      toggleSearch: [...document.querySelectorAll('.button.search')],
      closeSearch: [...document.querySelectorAll('.close-search')],
    };
  }

  _initialize() {
    // Don't init search js when on result page
    if (this._element.dataset.resultpage === 'true') {
      return;
    }

    this._state.show = this._options.show === 'true';
    this._elements.toggleSearch.forEach((el) => {
      el.addEventListener('click', () => {
        this._state.show = !this._state.show;
        clearAllBodyScrollLocks();
        if (this._state.show) {
          this._disableScroll();
        } else {
          this._enableScroll();
        }

        this._element.setAttribute('data-show', this._state.show);
      });
    });
    this._elements.closeSearch.forEach((el) => {
      el.addEventListener('click', () => {
        this._enableScroll();
        this._state.show = false;
        this._element.setAttribute('data-show', this._state.show);
      });
    });
  }

  _enableScroll() {
    this._elements.body.scrollTop = this._elements.html.scrollTop = this._state.scrollTop;
    this._state.scrollTop = 0;
    this._element.scrollTop = 0;
    enableBodyScroll(this._elements.body);
    this._elements.html.setAttribute('data-overflow', true);
  }

  _disableScroll() {
    this._state.scrollTop = this._elements.body.scrollTop || this._elements.html.scrollTop;
    disableBodyScroll(this._elements.body);
    this._elements.html.setAttribute('data-overflow', false);
  }
}

export default SearchBar;
